import { Omit } from '@material-ui/core';
import Grid, { GridProps } from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { PureComponent } from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import compose from 'recompose/compose';
import messages from '../../../intl/messages';
import { SegmentTypes } from '../../../models/itinerary';
import { ArrowWithLabel } from '../Arrow/ArrowWithLabel';

interface OwnProps extends Omit<GridProps, 'classes'> {
  stops?: number;
  stopCityCodes?: string[];
  type: SegmentTypes;
}

interface ArrowColumnProps
  extends OwnProps,
    WithStyles<typeof styles>,
    InjectedIntlProps {}

const showLabel = (type: SegmentTypes) => {
  switch (type) {
    case 'Air':
      return true;
    case 'Hotel':
    case 'Car':
      return false;
  }
};

class ArrowColumnBase extends PureComponent<ArrowColumnProps> {

  public render() {
    const { classes, stopCityCodes, stops, type, ...props } = this.props;

    const colored = ['Air'].includes(type) && !!stops && stops > 0;

    return (
      <Grid
        container
        item
        xs
        className={classes.root}
        justify="center"
        {...props}
      >
        <Grid item>
          <ArrowWithLabel
            colored={colored}
            stops={stops}
            label={this.getLabel()}
          />
        </Grid>
      </Grid>
    );
  }
  private getLabel = () => {
    const {
      stops,
      stopCityCodes,
      type,
      intl: { formatMessage },
    } = this.props;
    if (!showLabel(type)) return undefined;

    if (stops === 0) return formatMessage(messages.flight.direct);

    if (stops === 1 && stopCityCodes && stopCityCodes.length === 1) {
      return stopCityCodes[0];
    }

    return formatMessage(messages.flight.multipleStop);
  };
}

// styled
const styles = (theme: Theme) =>
  createStyles({
    root: {
      width: 'auto',

      /**
       * The top of the Arrow should be offset by the line-height
       * of the column labels (e.g. Depart / Arrive) so that the
       * arrow lines up nicely with the Arrival/Departure times
       */
      fontSize: theme.zeno.typography.body1.fontSize,
      marginTop: theme.zeno.typography.body1.lineHeight,
    },
  });

const enhance = compose<ArrowColumnProps, OwnProps>(
  withStyles(styles),
  injectIntl,
);

export const ArrowColumn = enhance(ArrowColumnBase);

ArrowColumn.displayName = 'ArrowColumn';
